module.exports = __webpack_public_path__ + "img/DAVID.e1447663.jpeg";